import {Injectable} from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'
import { MailTemplate } from '../models/mail-template';
import { HttpParams } from '@angular/common/http';
import { lastValueFrom, Observable } from 'rxjs';
import { MacroObjectType } from '../models/macro-object-type';
import { MacroDefinition } from '../models/macro-definition';

@Injectable({
    providedIn: 'root'
})

export class MailTemplatesService {

    constructor(private httpService: JsonHttpService) { }

    async getMailTemplates(): Promise<MailTemplate[]> {
        const mailTemplates = this.httpService.getTyped<MailTemplate[]>('/api/mailtemplate/get-mailtemplates');
        return await lastValueFrom(mailTemplates);
    }

    async getMailTemplateById(mailTemplateId: number): Promise<MailTemplate> {
        const options = { params: new HttpParams().set('templateId', `${mailTemplateId}`) };
        const mailTemplate = this.httpService.getTyped<MailTemplate>('/api/mailtemplate/get-mailtemplate-by-id', options);
        return await lastValueFrom(mailTemplate);
    }

    async getMailTemplateByKey(mailTemplateKey: string): Promise<MailTemplate> {
        const options = { params: new HttpParams().set('templateKey', mailTemplateKey) };
        const mailTemplate = this.httpService.getTyped<MailTemplate>('/api/mailtemplate/get-mailtemplate-by-key', options);
        return await lastValueFrom(mailTemplate);
    }

    async saveMailTemplate(mailTemplate: MailTemplate): Promise<MailTemplate> {
        const savedMailTemplate = this.httpService.post('/api/mailtemplate/save-mailtemplate', mailTemplate) as Observable<MailTemplate>;
        return await lastValueFrom(savedMailTemplate);
    }

    async getMacroDefinitions(objectType: MacroObjectType): Promise<MacroDefinition[]> {
        const options = { params: new HttpParams().set('objectType', objectType) };
        const macros = this.httpService.getTyped<MacroDefinition[]>('/api/mailtemplate/get-macrodefinitions', options);
        return await lastValueFrom(macros);
    }
}